import unifapImage from "./unifapImage";
let pdfMake = require("pdfmake/build/pdfmake");
let pdfFonts = require("pdfmake/build/vfs_fonts");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function(title, inscriptions) {
  let doc = { content: [] };
  let inscriptionAux = inscriptions.map((e) => [e.name, e.course, e.status]);
  doc.pageMargins = [40, 100, 40, 60];
  doc.header = {
    margin: 10,
    alignment: "center",
    columns: [
      [
        {
          width: 20,
          image: unifapImage,
        },
        { text: "MINISTÉRIO DA EDUCAÇÃO", bold: true },
        { text: "UNIVERSIDADE FEDERAL DO AMAPÁ", bold: true },
        {
          text:
            "Rod. Juscelino Kubitschek Km 2, Jardim Marco Zero – Macapá-AP, CEP 68.903-419 www.unifap.br",
          fontSize: 8,
        },
      ],
    ],
  };
  doc.content.push({
    alignment: "center",
    text: title,
    bold: true,
  });
  doc.content.push({
    alignment: "center",
    text: "INSCRIÇÕES CONFIRMADAS",
    bold: true,
  });
  doc.content.push({
    table: {
      headerRows: 1,
      widths: ["*", "*", "auto"],
      body: [
        [
          {
            text: "NOME",
            alignment: "center",
            bold: true,
          },
          {
            text: "CURSO",
            alignment: "center",
            bold: true,
          },
          {
            text: "SITUAÇÃO",
            alignment: "center",
            bold: true,
          },
        ],
        ...inscriptionAux,
      ],
    },
  });
  doc.pageOrientation = "landscape";
  pdfMake.createPdf(doc).download(`${title}.pdf`);
}
